// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hamburger-btn {
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 50;
  display: flex;
  height: 2.5rem;
  width: 2.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border: 1px solid var(--border-color);
  background-color: var(--background-color);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}
@media (min-width: 768px) {
  .hamburger-btn {
    display: none;
  }
}

.hamburger-icon {
  width: 1.25rem;
  height: 1.25rem;
  color: var(--text-color);
}

.app-root {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  background: var(--surface-primary);
  color: var(--text-primary);
}

.app-shell {
  display: flex;
  width: 100%;
  height: 100vh;
}
.app-shell.with-shell ::ng-deep app-header {
  display: none;
}
.app-shell.with-shell ::ng-deep app-home-footer {
  display: none;
}
.app-shell.with-shell ::ng-deep app-icon-rail {
  display: block;
  width: 0;
  overflow: visible;
}

.app-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  height: 100vh;
}
.with-shell .app-main {
  margin-left: 16rem;
  transition: margin-left 0.3s ease-in-out;
}
.with-shell .app-main.sidebar-collapsed-main {
  margin-left: 4rem;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .with-shell .app-main {
    margin-left: 4rem;
  }
}
@media (max-width: 767px) {
  .with-shell .app-main {
    margin-left: 0;
    padding-top: 3.5rem;
  }
  .with-shell .app-main.sidebar-collapsed-main {
    margin-left: 0;
  }
}

.app-content {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.version {
  position: absolute;
  bottom: 4px;
  right: 4px;
  margin: 0;
  color: #ccc;
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qCAAA;EACA,yCAAA;EACA,yCAAA;EACA,eAAA;AACF;AACE;EAhBF;IAiBI,aAAA;EAEF;AACF;;AACA;EACE,cAAA;EACA,eAAA;EACA,wBAAA;AAEF;;AACA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,0BAAA;AAEF;;AACA;EACE,aAAA;EACA,WAAA;EACA,aAAA;AAEF;AACI;EACE,aAAA;AACN;AACI;EACE,aAAA;AACN;AACI;EACE,cAAA;EACA,QAAA;EACA,iBAAA;AACN;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;AADF;AAGE;EACE,kBAAA;EACA,wCAAA;AADJ;AAGI;EACE,iBAAA;AADN;AAII;EARF;IASI,iBAAA;EADJ;AACF;AAGI;EAZF;IAaI,cAAA;IACA,mBAAA;EAAJ;EAEI;IACE,cAAA;EAAN;AACF;;AAKA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;AAFF","sourcesContent":[".hamburger-btn {\n  position: fixed;\n  top: 1rem;\n  left: 1rem;\n  z-index: 50;\n  display: flex;\n  height: 2.5rem;\n  width: 2.5rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.5rem;\n  border: 1px solid var(--border-color);\n  background-color: var(--background-color);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n\n  @media (min-width: 768px) {\n    display: none;\n  }\n}\n\n.hamburger-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  color: var(--text-color);\n}\n\n.app-root {\n  display: block;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n\n.app-shell {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n\n  &.with-shell {\n    ::ng-deep app-header {\n      display: none;\n    }\n    ::ng-deep app-home-footer {\n      display: none;\n    }\n    ::ng-deep app-icon-rail {\n      display: block;\n      width: 0;\n      overflow: visible;\n    }\n  }\n}\n\n.app-main {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  height: 100vh;\n\n  .with-shell & {\n    margin-left: 16rem;\n    transition: margin-left 0.3s ease-in-out;\n\n    &.sidebar-collapsed-main {\n      margin-left: 4rem;\n    }\n\n    @media (min-width: 768px) and (max-width: 1023px) {\n      margin-left: 4rem;\n    }\n\n    @media (max-width: 767px) {\n      margin-left: 0;\n      padding-top: 3.5rem;\n\n      &.sidebar-collapsed-main {\n        margin-left: 0;\n      }\n    }\n  }\n}\n\n.app-content {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.version {\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n  margin: 0;\n  color: #ccc;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
